import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import EmailCampaignsPage from './pages/EmailCampaignsPage.vue';
import APICampaignsPage from './pages/APICampaignsPage.vue';
import CampaignReportPage from './pages/Reports/CampaignReportPage.vue';
import WhatsAppCampaignWizard from './pages/WhatsAppCampaignWizard.vue';
import BlacklistPage from './pages/BlacklistPage.vue';
import TemplatesPage from './pages/TemplatesPage.vue';
import FollowUpPage from './pages/FollowUpPage.vue';
import FollowUpDetailPage from './pages/FollowUpDetailPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'campaigns_manage'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'sms/reports/:campaignParam',
          name: 'campaigns_sms_report',
          meta,
          component: CampaignReportPage,
          props: route => ({
            listRouteName: 'campaigns_sms_index',
            campaignParam: route.params.campaignParam,
          }),
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'whatsapp/wizard',
          name: 'campaigns_whatsapp_wizard',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignWizard,
        },
        {
          path: 'whatsapp/canvas',
          name: 'campaigns_whatsapp_canvas',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: () => import('./flow/CampaignFlowCanvas.vue'),
        },
        {
          path: 'whatsapp/flow/:campaignId',
          name: 'campaigns_whatsapp_flow',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: () => import('./flow/CampaignFlowCanvas.vue'),
        },
        {
          path: 'whatsapp/reports/:campaignParam',
          name: 'campaigns_whatsapp_report',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: CampaignReportPage,
          props: route => ({
            listRouteName: 'campaigns_whatsapp_index',
            campaignParam: route.params.campaignParam,
          }),
        },
        {
          path: 'api',
          name: 'campaigns_api_index',
          meta,
          component: APICampaignsPage,
        },
        {
          path: 'api/reports/:campaignParam',
          name: 'campaigns_api_report',
          meta,
          component: CampaignReportPage,
          props: route => ({
            listRouteName: 'campaigns_api_index',
            campaignParam: route.params.campaignParam,
          }),
        },
        {
          path: 'email',
          name: 'campaigns_email_index',
          meta,
          component: EmailCampaignsPage,
        },
        {
          path: 'email/reports/:campaignParam',
          name: 'campaigns_email_report',
          meta,
          component: CampaignReportPage,
          props: route => ({
            listRouteName: 'campaigns_email_index',
            campaignParam: route.params.campaignParam,
          }),
        },
        // Advanced campaign features
        {
          path: 'blacklist',
          name: 'campaigns_blacklist',
          meta,
          component: BlacklistPage,
        },
        {
          path: 'templates',
          name: 'campaigns_templates',
          meta,
          component: TemplatesPage,
        },
        {
          path: 'follow-up',
          name: 'campaigns_follow_up',
          meta,
          component: FollowUpPage,
        },
        {
          path: 'follow-up/:sequenceId',
          name: 'campaigns_follow_up_detail',
          meta,
          component: FollowUpDetailPage,
        },
        {
          path: 'short-links',
          name: 'campaigns_short_links_index',
          meta,
          component: () => import('./pages/ShortLinksPage.vue'),
        },
      ],
    },
  ],
};

export default campaignsRoutes;
